import React from 'react';
import './SnackbarContent.less';
import clsx from 'clsx';
import { Button } from '@progress/kendo-react-buttons';

interface Props {
  className?: string;
  description: string;
  action?: {
    label: string;
    disabled?: boolean;
    onClick?: () => void;
  };
}

// Move all snackbar-related styles and global overrides from notification-alerts.ts
// into this component. Make it independent and clean. We might switch to sonner in the future.
export function SnackbarContent({ className, description, action }: Props) {
  return (
    <div className={clsx('snackbar-content', className)}>
      <span>{description}</span>
      {action && (
        <Button
          themeColor="primary"
          className="snackbar-content__action"
          onClick={action.onClick}
          disabled={action.disabled}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
